import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {useParams} from 'react-router-dom';
import {Button, DescriptiveText, Page, Tile} from '../../../../../shared';
import {_setProfile} from '../../../../../shared/store';
import {_openModal} from '../../../../../shared/reducers/modals';
import Row from '../../../../../shared/components/Row';
import axiosInstance from '../../../../../shared/utils/axios';
import {calculateNewWindowDimensions} from '../../../../utils/partners';
import history from '../../../../../history';

const SFSConnect = (props) => {
  const {session, setProfile, openModal} = props;
  const {level} = useParams();
  const url = level === 'firm' ? `/firms/${session.profile.firm.id}/sfs` : `/advisors/${session.profile.id}/sfs/login`;
  const redirect = level === 'firm' ? '/engage/sfs/firmConfigure' : '/engage/sfs/individualConfigure';
  const mainMessage = level === 'firm' ? 'A window to login to Salesforce Financial Services should have opened. If it has not,'
    + ' please check your popup blocker. Once your admin user credentials have been approved and the window has been closed, press'
    + ' Continue to complete the firm connection.'
    : 'A window to login to Salesforce Financial Services should have opened. If it has not, please check your popup blocker.'
    + ' Once your user credentials have been approved and the window has been closed, press Continue to complete the connection';

  const notConnected = () => {
    const failMessage = level === 'firm' ? 'Your firm was not connected to Salesforce Financial Services.'
      + ' Make sure the correct credentials are entered into the Salesforce popup window and they are confirmed before continuing.'
      : 'You were not connected to Salesforce Financial Services. Make sure the correct credentials are entered into the Salesforce'
      + ' popup window and they are confirmed before continuing.';
    openModal({
      type: 'MessageModal',
      title: level === 'firm' ? 'Connection Failed' : 'Salesforce Connection Failed',
      body: failMessage,
    });
  };
  const sfsContinue = () => {
    axiosInstance.get(url)
      .then(res => {
        if (level === 'firm') {
          if (res && res.data && res.data.instance) {
            session.profile.sfsInstance = res.data.instance;
            setProfile(session.profile);
            openModal({
              type: 'MessageModal',
              title: 'Firm Connected to Salesforce',
              body: 'Your firm has been successfully connected to Salesforce Financial Services. Data will now sync between'
                + ' the two services, and your advisors can single sign-on to their individual view of Salesforce right within '
                + session.profile.brand.advisorPlatformName + '.',
            });
            history.push('/engage/sfs/firmConfigure');
          } else {
            notConnected();
          }
        } else {
          session.profile.sfsID = true;
          setProfile(session.profile);
          openModal({
            type: 'MessageModal',
            title: 'Salesforce Connected',
            body: 'You have been successfully connected to Salesforce Financial Services. '
              + 'You can now access Salesforce right within ' + session.profile.brand.advisorPlatformName
              + ' anytime from the header.',
          });
          history.push('/engage/sfs/sso');
        }
      })
      .catch(() => notConnected());
  };
  useEffect(() => {
    const authUrl = level === 'firm' ? `/firms/${session.profile.firm.id}/sfs/auth` : `/advisors/${session.profile.id}/sfs/auth`;
    axiosInstance.get(authUrl)
      .then(res => {
        const newWindow = calculateNewWindowDimensions(res.data, 'Salesforce');
        if (window.focus) {
          newWindow.focus();
        }
      })
      .catch(() => notConnected());
  }, []);
  return <Page>
    <Tile key='Connect Salesforce' title='Connect Salesforce'>
      <DescriptiveText>
        {mainMessage}
      </DescriptiveText>
      <Row wrap={false}>
        {/*TODO When the integrations page is completed: If cancelled change to go to the integrations page. */}
        <Button importance={'primary'}
                size={'md'}
                label={'Cancel'}
                action={() => history.push(redirect)} disabled={false}/>
        <Button importance={'primary'}
                size={'md'}
                label={'Continue'}
                action={() => sfsContinue()} disabled={false}/>
      </Row>
    </Tile>
  </Page>;
};

const mapStateToProps = state => ({
  session: state.session,
});
const mapDispatchToProps = dispatch => ({
  setProfile: profile => {
    dispatch(_setProfile(profile));
  },
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SFSConnect);

SFSConnect.propTypes = {
  /**
   * Is from Session Reducer
   */
  session: PropTypes.shape({profile: PropTypes.object}).isRequired,
  /**
   * From user reducer this function sets the profile
   */
  setProfile: PropTypes.func.isRequired,
  /**
   * The open modal function to dispatch _openModal from Redux
   */
  openModal: PropTypes.func.isRequired,
};
